import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../selections/selections.css";
import "../selections/selectionmedia.css";
import signupRestraImg from "assets/images/signup-restra.svg";
import earnRewardImg from "assets/images/eearn-rewards.svg";
import becomeDriverImg from "assets/images/become-driver.svg";

const Selections = () => {
  return (
    <div>
      <section className="selection-sec">
        <Container>
          <Row>
            <Col sm={4}>
              <div className="selection-card">
                {/* <Link to="/restaurant-signup/5"> */}
                <Link to="/restaurant-signup">
                  <div className="card-wrapper">
                    <figure className="mb-4">
                      <img src={signupRestraImg} alt="No_Image" />
                    </figure>
                    <figcaption>
                      <h5>Sign Up for Restaurant </h5>
                    </figcaption>
                  </div>
                </Link>
              </div>
            </Col>
            <Col sm={4}>
              <div className="selection-card">
                <Link to="/rewards">
                  <div className="card-wrapper">
                    <figure className="mb-4">
                      <img src={earnRewardImg} alt="No_Image" />
                    </figure>
                    <figcaption>
                      <h5>Earn Rewards with every Order</h5>
                    </figcaption>
                  </div>
                </Link>
              </div>
            </Col>
            <Col sm={4}>
              <div className="selection-card">
                {/* <Link to="/driver-signup/4"> */}
                <Link to="/driver-signup">
                  <div className="card-wrapper">
                    <figure className="mb-4">
                      <img src={becomeDriverImg} alt="No_Image" />
                    </figure>
                    <figcaption>
                      <h5>Become a Driver</h5>
                    </figcaption>
                  </div>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Selections;
